export const WEB_NAV_ID = 'root-nav';
export const WEB_ZOLA_CONTENT_CLASSNAME = 'content-wrapper';
export const WEB_ZOLA_FOOTER_ID = 'footer';
export const WEB_WEDDING_CONTENT_ID = 'zola-wedding-container';
export const WEB_WEDDING_SUB_NAV_CLASSNAME = 'menu-container';
